 <template>
  <div class="box">
    <div :style="{ width: '100%', height: '600px' }">
      <el-amap-search-box
        :visible="visible"
        :debounce="1000"
        @select="selectPoi"
        @choose="choosePoi"
        class="amp-map-search-box"
        :searchOption="searchOption"
        :on-search-result="onSearchResult"
      />
      <el-amap
        vid="amap"
        :plugin="plugin"
        class="amap-demo"
        :center="center"
        :events="events"
        :zoom="zoom"
        :expandZoomRange="true"
        mapStyle="normal"
      >
        <!-- 在地图上标记点 -->
        <el-amap-marker
          v-for="(marker, index) in markers"
          :position="marker.position"
          :events="markerEvents"
          :key="index"
        >
        </el-amap-marker>
        <el-amap-circle
          v-for="(marker, index) in markers"
          :center="marker.position"
          :events="markerEvents"
          :content="marker.content"
          :key="'circle' + index"
          :radius="30"
          :fillOpacity="0.3"
          :strokeOpacity="0.3"
          :strokeWeight="1"
        >
        </el-amap-circle>
        <el-amap-info-window
          v-for="(window, index) in markers"
          :position="window.position"
          :key="'win_' + index"
          :visible="window.visible"
          :offset="[0, -35]"
          :closeWhenClickMap="true"
          :showShadow="true"
        >
          <div style="padding: 10px; display: flex; flex-flow: column">
            <span style="padding: 10px">省份：{{ window.province }}</span>
            <span style="padding: 10px">城市：{{ window.city }}</span>
            <span style="padding: 10px">区域：{{ window.district }}</span>
            <span style="padding: 10px">地址：{{ window.address }}</span>
            <el-button @click="chooseIt(window)" size="small" type="primary"
              >选择</el-button
            >
          </div>
        </el-amap-info-window>
      </el-amap>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const that = this;
    return {
      center: [121.59996, 31.197646],
      lng: 0,
      lat: 0,
      loaded: false,
      visible: false,
      plugin: [
        {
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 100, //超过10秒后停止定位，默认：无穷大
          maximumAge: 0, //定位结果缓存0毫秒，默认：0
          convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: true, //显示定位按钮，默认：true
          buttonPosition: "RB", //定位按钮停靠位置，默认：'LB'，左下角
          showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
          showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：f
          extensions: "all",
          pName: "Geolocation",
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              o.getCurrentPosition();
              AMap.event.addListener(o, "complete", onComplete);
              AMap.event.addListener(o, "error", onError);

              function onComplete(data) {
                // data是具体的定位信息
                that.lng = data.position.lng;
                that.lat = data.position.lat;
                that.center = [that.lng, that.lat];
                this.markers = [{ position: [that.lng, that.lat] ,visible:false}];
                that.loaded = true;
                that.$nextTick();
              }

              function onError(data) {
                // 定位出错
                that.getLatLngLocation();
              }
            },
          },
        },
      ],
      events: {
        click(e) {
          that.handleClick(e);
        },
      },
      markers: [
        { position: [121.59996, 31.197646], visible: false },
      ],
      markerEvents: {
        click(e) {
          that.handleClickMarker(e);
        },
      },
      windowVisible: false,
      searchOption: {
        city: "杭州",
        citylimit: false,
      },
      zoom: 15,
      seleted: "",
    };
  },
  methods: {
    selectPoi() {
      console.log("selectPoi: ", e);
    },
    choosePoi() {
      console.log("choosePoi: ", e);
    },
    handleClick(e) {
      const that = this;
      let { lng, lat } = e.lnglat;
      this.lng = lng;
      this.lat = lat;
      this.markers = [{ position: [lng, lat] ,visible: false}];
      // 这里通过高德 SDK 完成。
      var geocoder = null;
      AMap.plugin(["AMap.Geocoder"], function () {
        geocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: "all",
        });
        geocoder.getAddress([lng, lat], function (status, result) {
          if (status === "complete" && result.info === "OK") {
            if (result && result.regeocode) {
              const addressComponent = result.regeocode.addressComponent;
              that.markers[0].visible = false;
              that.markers[0].address = result.regeocode.formattedAddress;
              that.markers[0].province = addressComponent.province;
              that.markers[0].city = addressComponent.city;
              that.markers[0].district = addressComponent.district;
              that.$nextTick(() => {
                that.markers[0].visible = true;
              });
            }
          }
        });
      });
    },
    handleClickMarker(e) {
      const that = this;
      let { lng, lat } = e.lnglat;
      this.lng = lng;
      this.lat = lat;
      var geocoder = null;
      const target = e.target;
      AMap.plugin(["AMap.Geocoder"], function () {
        geocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: "all",
        });
        geocoder.getAddress([lng, lat], function (status, result) {
          if (status === "complete" && result.info === "OK") {
            if (result && result.regeocode) {
              const addressComponent = result.regeocode.addressComponent;
              that.markers[0].visible = false;
              that.markers[0].address = result.regeocode.formattedAddress;
              that.markers[0].province = addressComponent.province;
              that.markers[0].city = addressComponent.city;
              that.markers[0].district = addressComponent.district;
              that.$nextTick(() => {
                that.markers[0].visible = true;
              });
            }
          }
        });
      });
    },
    onSearchResult(pois) {
      this.markers = [];
      if (pois.length > 0) {
        pois.forEach((poi) => {
          //this.markers.push({ position: [poi.lng, poi.lat] });
        });
        const poi = pois[0];
        this.center = [poi.lng, poi.lat];
        this.markers = [{ position: [poi.lng, poi.lat] ,visible: false}];
      }
    },
    getLatLngLocation() {
      var that = this
      AMap.plugin("AMap.CitySearch", function () {
        let citySearch = new AMap.CitySearch();
        citySearch.getLocalCity(function (status, result) {
          if (status === "complete" && result.info === "OK") {
            // 查询成功，result即为当前所在城市信息
            AMap.plugin("AMap.Geocoder", function () {
              let geocoder = new AMap.Geocoder({
                // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                city: result.adcode,
              });
              let lnglat01 = result.rectangle.split(";")[0].split(",");
              let lnglat02 = result.rectangle.split(";")[1].split(",")
              let lng = (parseFloat(lnglat01[0]) + parseFloat(lnglat02[0])) / 2
              let lat = (parseFloat(lnglat01[1]) + parseFloat(lnglat02[1])) / 2
              that.center = [lng,lat]
              that.markers = [{ position: [lng, lat] ,visible: false}];
            });
          }
        });
      });
    },
    chooseIt(marker) {
      this.$emit("choose-it", {
        province: marker.province,
        city: marker.city,
        district: marker.district,
        address: marker.address.replace(marker.province,'').replace(marker.city,'').replace(marker.district,''),
        fullAddress: marker.address
      });
    },
  },
};
</script>
<style lang="less">
.amp-map-search-box {
  position: absolute !important;
  top: 2px;
  left: 2px;
  border: 1px solid #cccccc;
  box-shadow: none !important;
}
</style>